import "./styles/TechnologiesPart.scss";

export const TechnologiesPart: React.FC = () => {
  return (
    <div id="skills" className="technologiesPart">
      <p className="mainTechnologiesPart">
        I like challenges, so I am always ready to learn new technologies.
      </p>
      <p className="secondaryTechnologiesPart">
        I have good skills in both front-end and back-end development
      </p>
    </div>
  );
};
